import { RouteDestination } from '@/modules/accredited-establishments/types/RouteDestination'

const GOOGLE_MAPS_DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1'

/*
 * A coordenada so entra quando as duas metades vem preenchidas: um par pela
 * metade montaria um `destination` malformado, e o endereco codificado leva o
 * Google a geocodificar na hora.
 */
const buildRouteUrl = ({ address, lat, lon }: RouteDestination): string => {
  const destination = lat && lon ? `${lat},${lon}` : encodeURIComponent(address)

  return `${GOOGLE_MAPS_DIRECTIONS_URL}&destination=${destination}`
}

export { buildRouteUrl }
